module.exports = __webpack_public_path__ + "img/sekacheva.e3eea9fb.jpg";